import React, { useState, useEffect } from "react";

import { toDateTimeISOStringFormat } from "../../../Services/string.service";

const DateRangePickers = (props) => {
  const [initialDateTime, setInitialDateTime] = useState(
    toDateTimeISOStringFormat(
      new Date(new Date().setDate(new Date().getDate() - 2)),
    ).replace("Z", ""),
  );
  const [endDateTime, setEndDateTime] = useState(
    toDateTimeISOStringFormat(new Date()).replace("Z", ""),
  );

  const handleDateInit = async (init) => {
    setInitialDateTime(init);
    if (props.setInitialDateTime) props.setInitialDateTime(init);
  };

  const handleEndDate = async (end) => {
    setEndDateTime(end);
    if (props.setEndDateTime) props.setEndDateTime(end);
  };

  useEffect(() => {
    if (props.initalDateTime)
      setInitialDateTime(toDateTimeISOStringFormat(props.initalDateTime)); // new Date() type
    else
      setInitialDateTime(
        toDateTimeISOStringFormat(
          new Date(new Date().setDate(new Date().getDate() - 2)),
        ).replace("Z", ""),
      );
  }, [props.initalDateTime]);

  useEffect(() => {
    if (props.endDateTime)
      setEndDateTime(toDateTimeISOStringFormat(props.endDateTime)); // new Date() type
    else setEndDateTime(toDateTimeISOStringFormat(new Date()).replace("Z", ""));
  }, [props.endDateTime]);

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="mb-3 row">
          <label
            htmlFor="filter-initial-date"
            className="col-md-4 col-form-label"
          >
            Início:
          </label>
          <div className="col-md-8">
            <input
              className="form-control"
              type="datetime-local"
              value={initialDateTime}
              onChange={async (e) => handleDateInit(e.target.value)}
              id="filter-initial-date"
            />
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="mb-3 row">
          <label htmlFor="filter-end-date" className="col-md-4 col-form-label">
            Fim:
          </label>
          <div className="col-md-8">
            <input
              className="form-control"
              type="datetime-local"
              value={endDateTime}
              onChange={async (e) => handleEndDate(e.target.value)}
              id="filter-end-date"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateRangePickers;
